export default __webpack_public_path__ + "static/media/white_logout_icon.8de87c32.svg";